module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Deer-88340e9a435bbf70332ec6b5a7b1e35d.svg";